import { CreateLevelDocument, CreateLevelMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateLevel = () => {
  const [mutate] = useMutation(CreateLevelDocument, {
    extractorFn: (data: CreateLevelMutation) => data.jobCatalogMutations.createJobcatalogLevel,
  })

  const createLevel = (name: string, roleId: string) => {
    return mutate({ variables: { name, roleId } })
  }

  return createLevel
}

export default useCreateLevel
